import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Banknote, ArrowLeft, Phone, DollarSign } from 'lucide-react';

const OrderCashPage = () => {
  const [searchParams] = useSearchParams();
  const customerName = searchParams.get('name') || 'Customer';
  const total = searchParams.get('total') || '0';

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(amount);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white py-8">
      <div className="max-w-xl mx-auto px-4">
        <Card className="border-green-200">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="h-8 w-8 text-green-600" />
            </div>
            <CardTitle className="text-2xl text-green-800">Order Reserved!</CardTitle>
            <CardDescription className="text-base">
              Your order has been reserved - please bring cash payment
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Order Summary */}
            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex justify-between items-center">
                <span className="text-stone-600">Order for:</span>
                <span className="font-semibold">{customerName}</span>
              </div>
              <div className="flex justify-between items-center mt-2">
                <span className="text-stone-600">Amount Due:</span>
                <span className="font-bold text-xl text-green-600">{formatCurrency(parseFloat(total))}</span>
              </div>
            </div>

            {/* Cash Payment Instructions */}
            <div className="space-y-4">
              <h3 className="font-semibold text-stone-800 flex items-center gap-2">
                <Banknote className="h-5 w-5 text-green-600" />
                Cash Payment Instructions
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                  <Phone className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-medium">Contact to Arrange Pickup</p>
                    <p className="text-sm text-stone-600">Lisa will contact you to arrange a pickup time and location</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3 p-3 bg-green-50 rounded-lg border border-green-200">
                  <DollarSign className="h-5 w-5 text-green-600 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-medium text-green-800">Exact Change Appreciated</p>
                    <p className="text-sm text-green-700">Please bring exact cash: <span className="font-bold">{formatCurrency(parseFloat(total))}</span></p>
                  </div>
                </div>
              </div>
            </div>

            {/* Important Note */}
            <div className="bg-amber-50 rounded-lg p-4 border border-amber-200">
              <p className="text-sm text-amber-800">
                <strong>Important:</strong> Your order has been reserved. Payment is required at pickup to receive your photos. If you have any questions, please contact Bright Eyes Photography.
              </p>
            </div>

            {/* What's Next */}
            <div className="space-y-2">
              <h4 className="font-medium text-stone-800">What happens next?</h4>
              <ul className="text-sm text-stone-600 space-y-1 list-disc list-inside">
                <li>You'll receive an email confirmation of your order</li>
                <li>Lisa will contact you to arrange pickup</li>
                <li>Bring cash payment to receive your photos</li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="text-center text-sm text-stone-500">
              <p>Questions? Contact Bright Eyes Photography</p>
              <p className="font-medium">lisa@brighteyesphotography.ca</p>
            </div>

            {/* Back Link */}
            <div className="pt-4 border-t">
              <Link to="/">
                <Button variant="outline" className="w-full">
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Return Home
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OrderCashPage;
